import { GET_RESERVATION_PROVIDERS_FAILURE, GET_RESERVATION_PROVIDERS_REQUEST, GET_RESERVATION_PROVIDERS_SUCCESS, GetReservationProvidersActionTypes, GetReservationProvidersState } from './types';

const defaultState: GetReservationProvidersState = {
  isLoading: false,
  errorMessage: "",
};

export default function getReservationProviders(state = defaultState, action: GetReservationProvidersActionTypes): GetReservationProvidersState {
  switch (action.type) {
    case GET_RESERVATION_PROVIDERS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_RESERVATION_PROVIDERS_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_RESERVATION_PROVIDERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};
